import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Modal, Button } from 'react-bootstrap';
import { resetModel } from '../../../../store/components/modelSlice';
import { putActivityDisabled } from '../../../../services/dashboard/battery';
import { message } from 'antd';

const Unablemodal = () => {
    const [show, setShow] = useState(true);
    const dispatch = useDispatch();
    const content = useSelector((state) => state.model.data);

    const handleSubmit = () => {
        putActivityDisabled(content)
            .then(response => {
                cancelHandler();
                message.success('停用成功');
                window.dispatchEvent(new Event('activityDataChanged')); 
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    const cancelHandler = () => {
        setShow(false);
        dispatch(resetModel()); 
    };

    return (
        <Modal className='driver-model' show={ show } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div style={{ color: 'red' }}>停用注意事項如下：</div>
                <div className="message-left">
                    1. 停用即表示該活動於隔日起即不建立新的車輛活動任務<br/>
                    2. 原先已建立的車輛活動任務將不受影響
                </div>
                <div className="button-container">
                    <Button variant="secondary" data-shadow onClick={ cancelHandler }>關閉</Button>
                    <Button variant="primary" data-shadow onClick={ handleSubmit }>確認</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default Unablemodal;